import { AuthApi } from "@/api/auth";
import { queryClient, QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const getMeQuery = () => {
  return queryClient.fetchQuery({
    queryKey: [QueryKey.MY_PROFILE],
    queryFn: AuthApi.getMe,
  });
};

export const useGetMeQuery = () => {
  const { data, isPending, isError } = useQuery({
    queryKey: [QueryKey.MY_PROFILE],
    queryFn: AuthApi.getMe,
  });

  return { me: data, isPending, isError };
};
